/* eslint-disable */
import { agreementContext } from '../context/PaymentInformationContext';
import React, { useState, useContext } from 'react';
import CONSTANTS from '../constants/constant';
import { calculateTotalDueAmount } from '../utils/calculateTotalDueAmount';
import { useParams } from 'react-router-dom';
import { ParamType } from '../interface/commonInterface';
import { CreatePaymentInfoForPayload } from '../utils/acceptPaymentUtills';
import { Sendtxt2pay } from '../../api/user';
import { ClipLoader } from 'react-spinners';
import { takePaymentStyles } from '../../stylesJS/makeStyles';
import { ReactComponent as TickIcon } from './../../assets/images/TickIcon.svg';
import { ReactComponent as AlertIcon } from './../../assets/apiErrorIcon.svg';
import {useTranslation} from 'react-i18next';
import {
  Grid,
  RACButton,
  Typography,
  RACModalCard,
} from '@rentacenter/racstrap';

interface MexicanChargeCardProps {
  setIsChargeCardModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setSaveCardModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  saveCardModalOpen: boolean;
}

export function MexicanChargeCard({
  setIsChargeCardModalOpen,
  setSaveCardModalOpen,
  saveCardModalOpen,
}: MexicanChargeCardProps) {
  const{t}=useTranslation('Payment');
  const classes: any = takePaymentStyles();
  const [isChargeCardPopupOpen, setIsChargeCardPopupOpen] =
    useState<boolean>(true);
  const { customerId } = useParams<ParamType>();
  const agreementInfo = useContext(agreementContext);
  const [displayInfo, setDisplayInfo] = useState<boolean>(false);
  const [loader, setLoader] = useState<boolean>(false);
  const [closeIcon, setCloseIcon] = useState<boolean>(false);
  const [message, setMessage] = useState<string>('');
  const {
    agreementDetails,
    customerInfo,
    storeInfo,
    paymentOrigin,
    coWorkerDetails,
    featureFlags,
    multiStoreSelected,
    countryCode
  } = agreementInfo;
  const base64String = window.sessionStorage.getItem('storeDetails') || '';
  const decodedString = atob(base64String);
  const jsonData = JSON.parse(decodedString);
  const country = jsonData.country || 'US';
  const onCloseEvent = () => {
    setIsChargeCardPopupOpen(false);
    setIsChargeCardModalOpen(false);
    setSaveCardModalOpen(false);
  };
  const regionCode = countryCode.filter((item) => item.abbreviation == country)[0]?.countryCodeValue;
  const handlePayment = async () => {
    const transactionDate = new Date();
    let totalTaxCollected = CONSTANTS.ZERO_NUMBER;

    const selectedAgreement = (agreementDetails || []).filter(
      (obj) => obj.selected
    );

    const totalAmountOfAgreements = selectedAgreement
      .map((agreement) => {
        totalTaxCollected += Number(agreement.totalTax);
        return calculateTotalDueAmount(agreement).toString();
      })
      .filter(
        (item) =>
          !item.includes(CONSTANTS.OPEN_BRACKET_STRING) &&
          !item.includes(CONSTANTS.CLOSE_BRACKET_STRING)
      );

    const totalAmount = totalAmountOfAgreements.reduce(
      (acc, item) => acc + Number(item),
      0
    );

    const donationAmount =
      featureFlags?.PaymentDonation === '1' &&
      Number(customerInfo.userEnteredDonationAmount) > 0
        ? Number(customerInfo.userEnteredDonationAmount)
        : 0;

    const finalTotalAmount = Number((totalAmount + donationAmount).toFixed(2));
    console.log(finalTotalAmount);

    const isCardSelected = false;
    const remainingSuspenseAmount = undefined; // Assuming this is defined elsewhere

    const postPaymentTextToPay = await CreatePaymentInfoForPayload(
      agreementDetails,
      undefined,
      undefined,
      isCardSelected,
      {
        customerId,
        agreementDetails,
        customerInfo,
        multiStoreSelected,
        featureFlags,
        paymentOrigin,
        coWorkerDetails,
        storeInfo,
      },
      remainingSuspenseAmount
    );

    const { customerDetails } = customerInfo;
    const {
      phoneNumber,
      zip,
      plus4,
      state,
      dob,
      emailAddress,
      firstName,
      lastName,
      addressLine1,
      city,
    } = customerDetails[0];

    const chargeCardReqparam = {
      optimizedPayload: { postPayment: [postPaymentTextToPay] },
      storeNumber: String(
        window.sessionStorage.getItem(CONSTANTS.STORE_NUMBER)
      ),
      customerId: String(customerId),
      isMXstore: featureFlags.MXStoreIdentifier === '1' ? 'Y' : 'N',
      newAddPayFlow: featureFlags?.enableAlternatePayment === '1' ? 'Y' : 'N',
      country,
      globalCustomerId: customerDetails[0].globalCustomerId || undefined,
      storeCoWorkerId: coWorkerDetails.employeeId,
      carryAmount: Number(customerInfo.amountUsed.carryRent),
      taxRate: Number(agreementDetails[0].taxRate),
      paymentOriginName: CONSTANTS.IN_STORE_VALUE,
      totalAmountCollected:
        Number(Number(customerInfo.amountUsed.remainingAmountDue).toFixed(2)) ||
        CONSTANTS.ZERO_NUMBER,
      totalTaxCollected:
        Number(totalTaxCollected.toFixed(2)) || CONSTANTS.ZERO_NUMBER,
      paymentId: CONSTANTS.EMPTY_STRING,
      cardAmount:
        Number(Number(customerInfo.amountUsed.remainingAmountDue).toFixed(2)) ||
        CONSTANTS.ZERO_NUMBER,
      cashAmount: CONSTANTS.ZERO_NUMBER,
      moneyOrderAmount: CONSTANTS.ZERO_NUMBER,
      checkAmount: CONSTANTS.ZERO_NUMBER,
      phoneNumber: featureFlags?.CountryCode == '1' ?String((customerDetails[0]?.countryCode ? customerDetails[0]?.countryCode : regionCode) + phoneNumber): String(phoneNumber),
      transactionDate: String(transactionDate),
      customerZip: `${zip}-${plus4}`,
      customerState: String(state),
      customerDOB: String(dob),
      cardDetails: [],
      documentDetails: [],
      paymentAmount: CONSTANTS.ZERO_NUMBER,
      cardFlag: CONSTANTS.EMPTY_STRING,
      emailAddress: String(emailAddress),
      originFee: CONSTANTS.ZREO_TWO_DECIMAL_STRING,
      totalAmountDue: Number(
        Number(customerInfo.amountUsed.remainingAmountDue).toFixed(2)
      ),
      wlDeposit: Math.max(
        Number(customerInfo.amountUsed.webLeadUsed),
        CONSTANTS.ZERO_NUMBER
      ),
      itSuspence: Math.max(
        Number(customerInfo.amountUsed.ipSuspenseUsed),
        CONSTANTS.ZERO_NUMBER
      ),
      suspense: CONSTANTS.ZERO_NUMBER,
      customerInfo: {
        FirstName: String(firstName),
        LastName: String(lastName),
      },
      creditOnAccount: Math.max(
        Number(customerInfo.amountUsed.coaUsed),
        CONSTANTS.ZERO_NUMBER
      ),
      firstName: String(firstName),
      lastName: String(lastName),
      address1: String(addressLine1),
      change: CONSTANTS.ZERO_NUMBER,
      stateProvince: String(state),
      postalCode: String(zip),
      city: String(city),
    };

    try {
      setLoader(true);
      const chargeCardResp = await Sendtxt2pay(chargeCardReqparam);
      setLoader(false);
      setCloseIcon(true);
      setMessage(
        Number(chargeCardResp.status) === 200
          ? CONSTANTS.SUCCESS
          : CONSTANTS.FAILED
      );
    } catch (e) {
      console.error(e); 
      setLoader(false);
      setMessage(CONSTANTS.FAILED);
    }
  };

  const SaveCardSubmitClick = async (): Promise<void> => {
    const mapPaymentData = (Payload: any) => ({
      optimizedPayload: {
        postPayment: [
          {
            paymentInfo: [
              {
                optimizedPayment: 'Y',
                amount: '',
                FirstName: Payload.firstName || '',
                LastName: Payload.lastName || '',
                storeMerchantId: null,
                coWorkerId: Payload.storeCoWorkerId || '',
                paymentOrigin: Payload.paymentOriginName || '',
                storeNumber: Payload.storeNumber || '',
                customerId: Payload.customerId || '',
                exceededFTAmount: null,
                agreementPayment: [{ agreementId: '' }],
                paymentMethod: {},
              },
            ],
          },
        ],
      },
      isMXstore: Payload.isMXstore,
      newAddPayFlow: Payload.newAddPayFlow,
      country: Payload.country,
      globalCustomerId: Payload.globalCustomerId,
      storeNumber: Payload.storeNumber,
      customerId: Payload.customerId,
      storeCoWorkerId: Payload.storeCoWorkerId,
      carryAmount: 0,
      taxRate: 0,
      paymentOriginName: Payload.paymentOriginName,
      totalAmountCollected: 0,
      save: '1',
      totalTaxCollected: 0,
      paymentId: '',
      cardAmount: 0,
      cashAmount: 0,
      moneyOrderAmount: 0,
      checkAmount: 0,
      phoneNumber: String(Payload.phoneNumber),
      transactionDate: String(new Date()),
      customerZip: Payload.customerZip,
      customerState: Payload.customerState,
      customerDOB: Payload.customerDOB,
      cardDetails: [],
      documentDetails: [],
      paymentAmount: 0,
      cardFlag: '',
      emailAddress: String(Payload.emailAddress),
      originFee: '0.00',
      totalAmountDue: 0,
      wlDeposit: 0,
      itSuspence: 0,
      suspense: 0,
      customerInfo: {
        FirstName: Payload.firstName || '',
        LastName: Payload.lastName || '',
      },
      creditOnAccount: 0,
      firstName: Payload.firstName || '',
      lastName: Payload.lastName || '',
      address1: Payload.address1 || '',
      change: 0,
      stateProvince: Payload.stateProvince || '',
      postalCode: Payload.postalCode || '',
      city: Payload.city || '',
    });

    const { customerDetails } = customerInfo;
    const customer = customerDetails[0];

    const Payload = {
      phoneNumber: featureFlags?.CountryCode == '1' ?String((customer?.countryCode ? customer?.countryCode : regionCode) + customer.phoneNumber):String(customer.phoneNumber),
      storeNumber: String(window.sessionStorage.getItem('storeNumber')),
      save: '1',
      customerId: String(customerId),
      isMXstore: featureFlags.MXStoreIdentifier === '1' ? 'Y' : 'N',
      newAddPayFlow: featureFlags?.enableAlternatePayment === '1' ? 'Y' : 'N',
      country, // Assuming country is defined
      globalCustomerId: customer.globalCustomerId || undefined,
      paymentOriginName: CONSTANTS.ORIGIN_STORE,
      transactionDate: String(new Date()),
      firstName: String(customer.firstName),
      lastName: String(customer.lastName),
      storeCoWorkerId: coWorkerDetails.employeeId, // Assuming coWorkerDetails is defined
    };

    const finalPayload = { ...mapPaymentData(Payload) };

    try {
      setLoader(true);

      const saveCardResp = await Sendtxt2pay(finalPayload);

      setLoader(false);
      setCloseIcon(true);

      setMessage(
        Number(saveCardResp?.status) === 200
          ? CONSTANTS.SUCCESS
          : CONSTANTS.FAILED
      );
    } catch (e) {
      console.error(e);
      setLoader(false);
    }
  };

  function ChargeCardPopup() {
    return (
      <>
        <Grid
          item
          md={12}
          className={`${classes.mt10px} ${classes.textCenter} ${classes.fontFamilyOpenSansBold} ${classes.fontSize16px}`}
        >
          <Typography>
            {t('Link will be sent to corresponding mobile number.')}
          </Typography>
        </Grid>
        <Grid
          item
          md={12}
          className={`${classes.mt10px} ${classes.textCenter} ${classes.fontSize16px}  ${classes.fontFamilyOpenSansBold}`}
        >
          <Typography>{t('Do you want to proceed?')}</Typography>
        </Grid>
        <Grid item md={12} className={`${classes.alc} `}>
          <RACButton
            className={`${classes.mx1} ${classes.floatRight} ${classes.p1520}`}
            variant="outlined"
            color="primary"
            data-bs-dismiss="modal"
            onClick={() => {
              onCloseEvent();
            }}
            data-testid="NoChargeCard"
          >
            {t('No')}
          </RACButton>
          <RACButton
            className={`${classes.mx1} ${classes.floatRight} ${classes.p1520}`}
            color="primary"
            variant="contained"
            data-bs-dismiss="modal"
            onClick={() => {
              setDisplayInfo(true);
              saveCardModalOpen ? SaveCardSubmitClick() : handlePayment(); // Call handlePayment directly
              setIsChargeCardPopupOpen(false); // Close the charge card popup
            }}
            data-testid="YesChargeCard"
          >
            {t('Yes')}
          </RACButton>
        </Grid>
      </>
    );
  }

  function onOkCLick() {
    setDisplayInfo(false);
    setIsChargeCardModalOpen(false);
    setSaveCardModalOpen(false);
    setMessage('');
  }
  function DisplayInfoPopup() {
    return (
      <>
        <Grid className={classes.alc}>
          <ClipLoader color="blue" loading={loader} size={40} />
        </Grid>
        {message == '' && (
          <>
            <Typography
              className={`${classes.alc} ${classes.mt10px}  ${classes.fontSize16px}  ${classes.fontFamilyOpenSansBold}`}
            >
              {t('Link is being sent')}
            </Typography>
            <span className={`${classes.alc}`}>{t('Please wait')}</span>
          </>
        )}
        {message !== '' && message === CONSTANTS.SUCCESS && (
          <>
            <Grid className={classes.alc} style={{marginTop:'0px'}}>
              <TickIcon />
            </Grid>
            <Typography
              className={`${classes.alc} ${classes.mt10px}  ${classes.fontSize18px}  ${classes.fontFamilyOpenSansBold}`}
            >
              {t('Link has been sent')}
            </Typography>
            <Typography
              className={`${classes.alc} ${classes.mt3px}  ${classes.fontSize18px}  ${classes.fontFamilyOpenSansBold}`}
            >
              {t('Successfully')}
            </Typography>
            <Grid className={` ${classes.alc} ${classes.mt10px}`}>
              <RACButton
                className={`${classes.mx1} ${classes.alc} ${classes.mt10px}`}
                color="primary"
                variant="contained"
                data-bs-dismiss="modal"
                onClick={() => {
                  onOkCLick();
                }}
                data-testid="YesChargeCard"
              >
                {t("Ok")}
              </RACButton>
            </Grid>
          </>
        )}

        {message !== '' && message === CONSTANTS.FAILED && (
          <>
            <Grid className={classes.alc} style={{marginTop:'0px'}}>
              <AlertIcon />
            </Grid>
            <Typography
              className={`${classes.alc} ${classes.mt10px}  ${classes.fontSize16px}  ${classes.fontFamilyOpenSansBold}`}
            >
              {t('The link is not sent')}
            </Typography>
            <Typography
              className={`${classes.alc} ${classes.mt3px}  ${classes.fontSize16px}  ${classes.fontFamilyOpenSansBold}`}
            >
              {t('Please try again later')}
            </Typography>
            <Grid className={` ${classes.alc} ${classes.mt10px}`}>
              <RACButton
                className={`${classes.mx1} ${classes.alc} ${classes.mt10px}`}
                color="primary"
                variant="contained"
                data-bs-dismiss="modal"
                onClick={() => {
                  onOkCLick();
                }}
                data-testid="YesChargeCard"
              >
                {t('Ok')}
              </RACButton>
            </Grid>
          </>
        )}
      </>
    );
  }

  return (
    <>
      {isChargeCardPopupOpen && (
        <RACModalCard
          isOpen={isChargeCardPopupOpen}
          maxWidth="xs"
          borderRadius="4%"
          closeIcon={true}
          onClose={() => {
            onCloseEvent();
          }}
        >
          <ChargeCardPopup />
        </RACModalCard>
      )}
      {displayInfo && (
        <RACModalCard
          isOpen={displayInfo}
          maxWidth="xs"
          borderRadius="4%"
          closeIcon={closeIcon}
          onClose={() => {
            setIsChargeCardPopupOpen(false);
            setIsChargeCardModalOpen(false);
            setSaveCardModalOpen(false);
            setCloseIcon(true);
          }}
          className={`${classes.maxWidth350px} ${classes.pb5px}`}
        >
          <DisplayInfoPopup />
        </RACModalCard>
      )}
    </>
  );
}